const APPCONFIG = {
  version: '2.0.2',
  enviroment: 'dev'
}
export default APPCONFIG
